export default "__VITE_ASSET__B9O$1A8p__"